import Chart from 'react-apexcharts';
import NoDataAlert from '../../common/returns/NoDataAlert';

const ChartGroupBarDefault = ({ disponivel, necessario }) => {
	if (!disponivel && !necessario) {
		return <NoDataAlert />;
	}

	const series = [
		{
			name: 'Necessario',
			data: [necessario || 0],
			color: '#02FFA9',
		},
		{
			name: 'Disponível',
			data: [disponivel || 0],
			color: '#0CABF5',
		},
	];

	const options = {
		chart: {
			stacked: false,
			toolbar: {
				show: false,
			},
		},
		grid: {
			show: false,
			borderColor: '#40475D',
			strokeDashArray: 0,
		},
		plotOptions: {
			bar: {
				borderRadius: 3,
				borderRadiusApplication: 'end',
				borderRadiusWhenStacked: 'last',
				columnWidth: '100%',
				horizontal: false,
				dataLabels: {
					position: 'top',
				},
			},
		},
		dataLabels: {
			enabled: true,
			textAnchor: 'middle', //
			style: {
				colors: ['#FFF'],
				fontSize: '14px',
			},
			background: {
				enabled: false,
				dropShadow: {
					enabled: true,
					top: 3,
					left: 3,
					blur: 3,
				},
			},
			formatter: function (val) {
				return val.toLocaleString('pt-BR', {
					maximumFractionDigits: 2,
				});
			},
			offsetY: -30,
			offsetX: 0,
			dropShadow: {
				enabled: true,
				left: 2,
				top: 2,
				opacity: 0.5,
			},
		},
		stroke: {
			width: 1,
			colors: ['#33333380'],
		},
		xaxis: {
			categories: ['Capacidade'],
			position: 'top',
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			labels: {
				show: false,
				style: {
					colors: 'white',
					fontSize: '16px',
				},
				offsetY: 10,
			},
		},
		yaxis: {
			reversed: false,
			opposite: false,
			floating: false,
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			labels: {
				show: false,
				style: {
					colors: '#40475D',
					fontSize: '12px',
					fontStyle: 'bold',
				},
			},
		},
		tooltip: {
			theme: 'dark',
			shared: true,
			intersect: false,
			y: {
				show: true,
				formatter: function (value) {
					var formattedValue = new Intl.NumberFormat(
						'pt-BR'
					).format(value.toFixed(2));
					return formattedValue;
				},
			},
		},

		fill: {
			type: 'gradient',
			gradient: {
				type: 'radial',
				shadeIntensity: 1,
				gradientToColors: ['#02FFA980', '#6078ea'],
				inverseColors: false,
				opacityFrom: 1,
				opacityTo: 1,
				stops: [],
				colorStops: [],
			},
		},
		legend: {
			show: true,
			showForSingleSeries: true,
			showForNullSeries: true,
			showForZeroSeries: true,
			floating: false,
			position: 'top',
			horizontalAlign: 'center',
			fontStyle: 'bold',
			fontColor: 'white',
			fontSize: '14px',
			offsetX: 0,
			offsetY: 0,
			labels: {
				colors: 'white',
				useSeriesColors: false,
			},
			onItemClick: {
				toggleDataSeries: true,
			},
			onItemHover: {
				highlightDataSeries: true,
			},
		},
	};

	return (
		<div className="bg-transparent w-full h-full px-2">
			<Chart
				options={options}
				series={series}
				type="bar"
				width="100%"
				height={180}
			/>
		</div>
	);
};

export default ChartGroupBarDefault;
